import FrameComponent3 from "./FrameComponent3";

const Splash2 = () => {
  return (
    <div className="w-full relative bg-[#f2ece3] overflow-hidden flex flex-col items-start pt-[74px] pb-3 pl-[100px] pr-[50px] box-border gap-[62px] leading-[normal] tracking-[normal] text-left text-base text-[#353434] font-[Mingzat] mq750:gap-[31px] mq750:pl-[50px] mq750:pr-[25px] mq750:box-border mq450:gap-[15px] mq450:pl-5 mq450:box-border">
      <main className="self-stretch flex items-start gap-[108px] max-w-full mq750:gap-[54px] mq450:gap-[27px] mq1050:flex-wrap">
        <img
          className="w-[600px] relative rounded-[20px] max-h-full object-cover max-w-full mq1050:flex-1"
          loading="lazy"
          alt=""
          src="./Rectangle-6@2x.png"
        />
        <FrameComponent3 />
      </main>
      <div className="flex items-start py-0 px-[463px] box-border max-w-full mq750:pl-[115px] mq750:pr-[115px] mq750:box-border mq450:pl-5 mq450:pr-5 mq450:box-border mq1050:pl-[231px] mq1050:pr-[231px] mq1050:box-border">
        <div className="relative">
          {`2026 |  | `}
          <span className="[text-decoration:underline]">Terms of Use</span>
          {` | `}
          <span className="[text-decoration:underline]">Privacy Policy</span>
        </div>
      </div>
    </div>
  );
};

export default Splash2;
